// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1zExL","disabled":"FileBtn_disabled__23N0Y","warn":"FileBtn_warn__2BWqn","fade":"FileBtn_fade__35iWi"};